<script>
    import ContextualText from '../Workspaces/ElementView/ContextualText.svelte';
    import ContextualFieldLink from "../ContextualFieldLink.svelte";
    import ContextualTextInput from "../ContextualTextInput.svelte";
    import {editable as isActivityEditable} from '../Workspaces/workspacesStore';
    import {sgettext} from '../../i18n.js';
    import {approvalInfo} from '../Diff/diffStore.js';

    export let editable = false;
    export let onChange = () => {};
    export let focus;
    export let showEditLinks = true;
    export let persistentOnChange = onChange;
    export let persistentFields = [];
    export let persistentOnFocus = () => {};

    // -- model.action_id field is modified in the serializer to reflect the changes required when APM is enabled.
    // -- APM enabled -- model.action_id is a concatenation of element_instance.action_version_id and element_instance.action_version.extracted_name
    // -- APM disabled -- model.action_id is element_instance.action_id (also referred to as Legacy Action ID)
    export let model = {};

    $: actionPersist = persistentFields.includes('action_id');
    $: lmiPersist = persistentFields.includes('lowest_maintainable_item');
    $: execPersist = persistentFields.includes('execution_condition');

    $: isApmEnabledTemplate = $approvalInfo.isApmEnabledTemplate;
    $: isQualityOrSafetyElement = model?.type === "QUALITY" || model?.type === "SAFETY";
</script>

<div class="wrapper">
    {#if isQualityOrSafetyElement && $approvalInfo.isWorkManaged}
        <div>
            <ContextualText><strong>{sgettext('$$ACTION$$')}</strong></ContextualText>
        </div>
        <div>
        {#if editable}
            <ContextualTextInput
            id="action_id"
            value={model.action_id}
            object={model}
            focus={focus === 'action_id'}
            on:change={actionPersist ? persistentOnChange : onChange}
            on:focus={actionPersist
                ? () => persistentOnFocus('action_id')
                : () => {}}
            />
        {:else}
            <ContextualText>
                {model.action_id ? model.action_id : ''}
            </ContextualText>
            {#if showEditLinks && $isActivityEditable}
                <ContextualFieldLink focus="action_id" value={model.action_id} />
            {/if}
        {/if}
        </div>
    {/if}

    {#if isApmEnabledTemplate && isQualityOrSafetyElement && model.is_apm_enabled_element_instance}
        <div>
            <ContextualText
            ><strong>{sgettext('$$EQUIPMENT_ID$$')}</strong></ContextualText
            >
        </div>
        <div>
            <ContextualText>
                {model.equipment_id ? model.equipment_id : ''}
            </ContextualText>
        </div>

        <div>
            <ContextualText
            ><strong>{sgettext('$$COMPONENT$$')}</strong></ContextualText
            >
        </div>
        <div>
            <ContextualText>
                {model.action_component ? model.action_component : ''}
            </ContextualText>
        </div>
        <div>
            <ContextualText
            ><strong>{sgettext('$$LOCATION_ON_LMI$$')}</strong></ContextualText
            >
        </div>
        <div>
            <ContextualText>
                {model.apm_location ? model.apm_location : ''}
            </ContextualText>
        </div>
    {/if}

  <div>
    <ContextualText
      ><strong>{sgettext('$$LOWEST_MAINTAINABLE_ITEM$$')}</strong></ContextualText
    >
  </div>
  <div>
    {#if editable && $isActivityEditable}
      <ContextualTextInput
        id="lowest_maintainable_item"
        value={model.lowest_maintainable_item}
        object={model}
        focus={focus === 'lowest_maintainable_item'}
        on:change={lmiPersist ? persistentOnChange : onChange}
        on:focus={lmiPersist
          ? () => persistentOnFocus('lowest_maintainable_item')
          : () => {}}
      />
    {:else}
      <ContextualText>
        {model.lowest_maintainable_item ? model.lowest_maintainable_item : ''}
      </ContextualText>
      {#if showEditLinks && $isActivityEditable}
        <ContextualFieldLink
          focus="lowest_maintainable_item"
          value={model.lowest_maintainable_item}
        />
      {/if}
    {/if}
  </div>
  <div>
    <ContextualText
      ><strong>{sgettext('$$EXECUTION_CONDITION$$')}</strong></ContextualText
    >
  </div>
  <div>
    {#if editable && $isActivityEditable}
      <ContextualTextInput
        id="execution_condition"
        value={model.execution_condition}
        object={model}
        focus={focus === 'execution_condition'}
        on:change={execPersist ? persistentOnChange : onChange}
        on:focus={execPersist
          ? () => persistentOnFocus('execution_condition')
          : () => {}}
      />
    {:else}
      <ContextualText>
        {model.execution_condition ? model.execution_condition : ''}
      </ContextualText>
      {#if showEditLinks && $isActivityEditable}
        <ContextualFieldLink
          focus="execution_condition"
          value={model.execution_condition}
        />
      {/if}
    {/if}
  </div>
</div>

<style>
  .wrapper {
    display: grid;
    grid-template-rows: repeat(3, auto);
    grid-template-columns: auto 1fr;
    grid-gap: 15px;
    background-color: #f8f9fa;
    border: 1px solid #ced4da;
  }

  .wrapper > div {
    padding: 10px;
  }
</style>
